import type { ComponentProps } from 'react';
import React, { type PropsWithChildren, useEffect } from 'react';
import { useUseDesk } from '@periodica/usedesk';
import { Link } from '../Link';

export function SupportLink({
  children,
  type,
  variant,
  onClick,
  preload = false,
}: PropsWithChildren<{
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  preload?: boolean;
  variant?: ComponentProps<typeof Link>['variant'];
  type?: string;
}>) {
  const widget = useUseDesk();

  if (!widget) {
    throw new Error('SupportLink must be used within a UseDeskProvider');
  }

  useEffect(() => {
    if (preload) {
      widget.load();
    }
  }, [widget, preload]);

  return (
    <Link variant={variant} asChild>
      <button
        type="button"
        onClick={(e) => {
          if (onClick) {
            onClick(e);
          }

          widget.load();
          widget.open(type).catch(() => {
            const link = document.createElement('a');
            link.href = 'https://periodica.press/contacts/';
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            link.click();
          });
        }}
      >
        {children}
      </button>
    </Link>
  );
}
